module.exports = __webpack_public_path__ + "assets/img/Type E (13).b0bb2ac0.jpg";